import { Flame, Grid3x3, Sparkles, Star } from 'lucide-react';

// Slot sayfasının vitrin sekmeleri. Kimlikler doğrudan /games?flag=...
// değerleridir. Liste tek yerdedir: Betrun'un sol menüsü aynı sekmeleri
// "Slotlar"ın alt maddeleri olarak çizer (`?filtre=<id>`) — Canlı Casino'nun
// masa sekmeleriyle aynı kalıp (lib/liveCasinoTabs.js).
export const SLOT_TABS = [
  { id: 'all', name: 'Tümü', icon: Grid3x3 },
  { id: 'hot', name: 'Popüler', icon: Flame },
  { id: 'new', name: 'Yeni', icon: Sparkles },
  { id: 'featured', name: 'Öne Çıkanlar', icon: Star },
];

// Sekme adreste taşınır: menüden gelen bağlantı ve yenilenen sayfa aynı
// sekmeyi açar. Tanınmayan değer "Tümü"ne düşer.
export const SLOT_TAB_PARAM = 'filtre';

export const slotTabFrom = (search) => {
  const id = new URLSearchParams(search || '').get(SLOT_TAB_PARAM);
  return SLOT_TABS.some((t) => t.id === id) ? id : 'all';
};

export const slotTabPath = (id) => (
  id && id !== 'all' ? `/slotlar?${SLOT_TAB_PARAM}=${id}` : '/slotlar'
);
